import { render, staticRenderFns } from "./submit-popup.vue?vue&type=template&id=b65ea962&scoped=true&"
import script from "./submit-popup.vue?vue&type=script&lang=js&"
export * from "./submit-popup.vue?vue&type=script&lang=js&"
import style0 from "./submit-popup.vue?vue&type=style&index=0&id=b65ea962&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ea962",
  null
  
)

export default component.exports